
export default {
  props: {
    value: {
      type: null,
      required: true,
    },

    rules: {
      type: [String, Object],
      default: '',
    },

    name: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      default: '',
    },

    hideLabel: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: 'text',
    },

    placeholder: {
      type: String,
      default: '',
    },

    rows: {
      type: Number,
      default: 4,
    },

    validationMode: {
      type: String,
      default: 'lazy',
    },

    bgColor: {
      type: String,
      default: 'gray',
    },

    instructions: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      innerValue: '',
    }
  },

  watch: {
    innerValue(newVal) {
      this.$emit('input', newVal)
    },

    value(newVal) {
      this.innerValue = newVal
    },
  },

  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
